/*eslint-disable */
/* eslint-disable no-bitwise */
import apiService from 'apiService/ApiService'

class RuntimeImportService {
  constructor() {
    window.mysticalSteakhouse = window.mysticalSteakhouse || []
    let jsonpArray = window.mysticalSteakhouse
    const oldJsonpFunction = jsonpArray.push.bind(jsonpArray)
    jsonpArray.push = this.webpackJsonpCallback
    jsonpArray = jsonpArray.slice()
    jsonpArray.forEach((v) => {
      this.webpackJsonpCallback(v)
    })
    this.parentJsonpFunction = oldJsonpFunction
    this.modules = __webpack_require__.m // eslint-disable-line
    this.map = null
  }
  async getPagesMap() {
    const data = await apiService.run('getPagesMap')
    return data
  }
  webpackJsonpCallback(data) {
    const chunkIds = data[0]
    const moreModules = data[1]

    // add "moreModules" to the modules object,
    // then flag all "chunkIds" as loaded and fire callback
    const resolves = []
    chunkIds.forEach((v, i) => {
      const chunkId = chunkIds[i]
      if (this.installedChunks[chunkId]) {
        resolves.push(this.installedChunks[chunkId][0])
      }
      this.installedChunks[chunkId] = 0
    })
    Object.keys(moreModules).forEach((moduleId) => {
      this.modules[moduleId] = moreModules[moduleId]
    })
    if (this.parentJsonpFunction) {
      this.parentJsonpFunction(data)
    }

    resolves.forEach(() => {
      resolves.shift()()
    })
  }
  // The module cache
  installedModules = {}
  // object to store loaded and loading chunks
  // undefined = chunk not loaded, null = chunk preloaded/prefetched
  // Promise = chunk loading, 0 = chunk loaded
  installedChunks = {
  }
  // script path function
  jsonpScriptSrc(name) {
    return `${this.p}${name}.bundle.js`
  }
  // The require function
  async require(moduleId) {
    if (!this.map) {
      this.map = await this.getPagesMap()
    }
    let mysticalModule = false
    window.webpackJsonp.forEach((c) => {
      if (c[0][0] === moduleId) {
        const moduleIndexJS = this.map[`./${moduleId.substring(0, moduleId.indexOf('-'))}/index`][0]
        mysticalModule = c[1][moduleIndexJS]
      }
    })
    if (mysticalModule) {
      this.modules[moduleId] = mysticalModule
    }

    // Check if module is in cache
    if (this.installedModules[moduleId]) {
      return this.installedModules[moduleId].exports
    }
    // Create a new module (and put it into the cache)
    this.installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {},
    }
    const module = this.installedModules[moduleId]

    // Execute the module function
    this.modules[moduleId].call(module.exports, module, module.exports, __webpack_require__) // m => this.require(m))

    // Flag the module as loaded
    module.l = true

    // Return the exports of the module
    return module.exports
  }
  // This file contains only the entry chunk.
  // The chunk loading function for additional chunks
  e(chunkId, appPath) { // eslint-disable-line max-statements
    const promises = []

    // JSONP chunk loading for javascript
    let installedChunkData = this.installedChunks[chunkId]
    if (installedChunkData !== 0) { // 0 means "already installed".
      // a Promise means "currently loading".
      if (installedChunkData) {
        promises.push(installedChunkData[2])
      } else {
        // setup Promise in chunk cache
        const promise = new Promise((resolve, reject) => {
          installedChunkData = this.installedChunks[chunkId] = [resolve, reject]
        })
        promises.push(installedChunkData[2] = promise)

        // start chunk loading
        const head = document.getElementsByTagName('head')[0]
        const script = document.createElement('script')

        script.charset = 'utf-8'
        script.timeout = 120
        if (this.nc) {
          script.setAttribute('nonce', this.nc)
        }
        script.src = `${appPath}` + this.jsonpScriptSrc(chunkId)

        const onScriptComplete = (event) => {
          // avoid mem leaks in IE.
          script.onerror = script.onload = null
          clearTimeout(timeout)
          // const chunk = this.installedChunks[chunkId]
          let chunk = false
          window.webpackJsonp.forEach((c) => {
            if (c[0][0] === chunkId) {
              chunk = 0
              this.webpackJsonpCallback(c)
            }
          })
          if (chunk !== 0) {
            if (chunk) {
              var errorType = event && (event.type === 'load' ? 'missing' : event.type)
              var realSrc = event && event.target && event.target.src
              var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')')
              error.type = errorType
              error.request = realSrc
              chunk[1](error)
            }
            this.installedChunks[chunkId] = undefined
          }
        }
        const timeout = setTimeout(function() {
          onScriptComplete({ type: 'timeout', target: script })
        }, 120000)
        script.onerror = script.onload = onScriptComplete
        head.appendChild(script)
      }
    }
    return Promise.all(promises)
  }
  // expose the modules object (__webpack_modules__)
  m = this.modules
  // expose the module cache
  c = this.installedModules
  // define getter function for harmony exports
  d(exports, name, getter) {
    if (!this.o(exports, name)) {
      Object.defineProperty(exports, name, { enumerable: true, get: getter })
    }
  }
  // define __esModule on exports
  r(exports) {
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' })
    }
    Object.defineProperty(exports, '__esModule', { value: true })
  }
  // create a fake namespace object
  // mode & 1: value is a module id, require it
  // mode & 2: merge all properties of value into the ns
  // mode & 4: return value when already ns object
  // mode & 8|1: behave like require
  async t(value, mode) {
    if (mode & 1) value = await this.require(value)
    if (mode & 8) return value
    if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value
    const ns = Object.create(null)
    this.r(ns)
    Object.defineProperty(ns, 'default', { enumerable: true, value })
    if (mode & 2 && typeof value !== 'string') {
      for (var key in value) {
        this.d(ns, key, function(key) { return value[key]; }.bind(null, key))
      }
    }
    return ns
  }
  // getDefaultExport function for compatibility with non-harmony modules
  n(module) {
    const getter = module && module.__esModule ?
      function getDefault() { return module['default'] } :
      function getModuleExports() { return module }
    this.d(getter, 'a', getter)
    return getter
  }
  // Object.prototype.hasOwnProperty.call
  o(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property)
  }
  // __webpack_public_path__
  p = '/'
  // on error function for async loading
  oe(err) {
    console.error(err)
    throw err
  }
  async performMysticalOperation(opts) {
    const { name, appPath } = opts
    console.log('Mystical Operation:', name)
    if (!this.maps) {
      this.maps = await this.getPagesMap()
    }
    const ourPage = this.maps[`./${name}/index`]
    return Promise.all(ourPage.slice(1)
    .map(id => this.e(id, appPath))).then(() => {
      const id = ourPage[0]
      return this.t(id, 7)
    })
  }
}

export default new RuntimeImportService()
